var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsRoomSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 30L17.1667 19.5C16.3333 20.1667 15.375 20.6944 14.2917 21.0833C13.2083 21.4722 12.0556 21.6667 10.8333 21.6667C7.80556 21.6667 5.24333 20.6178 3.14667 18.52C1.05 16.4222 0.00111111 13.86 0 10.8333C0 7.80556 1.04889 5.24333 3.14667 3.14667C5.24444 1.05 7.80667 0.00111111 10.8333 0C13.8611 0 16.4239 1.04889 18.5217 3.14667C20.6194 5.24444 21.6678 7.80667 21.6667 10.8333C21.6667 12.0556 21.4722 13.2083 21.0833 14.2917C20.6944 15.375 20.1667 16.3333 19.5 17.1667L30 27.6667L27.6667 30ZM10.8333 18.3333C12.9167 18.3333 14.6878 17.6044 16.1467 16.1467C17.6056 14.6889 18.3344 12.9178 18.3333 10.8333C18.3333 8.75 17.6044 6.97944 16.1467 5.52167C14.6889 4.06389 12.9178 3.33444 10.8333 3.33333C8.75 3.33333 6.97944 4.06278 5.52167 5.52167C4.06389 6.98056 3.33444 8.75111 3.33333 10.8333C3.33333 12.9167 4.06278 14.6878 5.52167 16.1467C6.98056 17.6056 8.75111 18.3344 10.8333 18.3333Z",
    fill: "#88A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsRoomSearch);
export default __webpack_public_path__ + "static/media/NewsRoomSearch.e1549aeefc265d341610ee4cbc52d3bf.svg";
export { ForwardRef as ReactComponent };